import {
  CalendarEvent,
  CalendarReminder,
  CreateCalendarEvent,
  CreateCalendarReminder,
  GenericCalendarEntry,
  UpdateCalendarEvent,
  UpdateCalendarReminder,
} from '@/models/CalendarEntry';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getPropertyCalendarEntries = async (propertyId?: string) => {
  if (!propertyId) {
    return [];
  }

  const url = `/properties/${propertyId}/calendar`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<GenericCalendarEntry[]>(url);

  return response.data;
};

export const createCalendarEvent = async ({
  propertyId,
  data,
}: {
  propertyId: string;
  data: CreateCalendarEvent;
}) => {
  const url = '/calendar/events';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<CalendarEvent>(url, { ...data, propertyId });

  return response.data;
};

export const updateCalendarEvent = async ({
  id,
  data,
}: {
  id: string;
  data: UpdateCalendarEvent;
}) => {
  const url = `/calendar/events/${id}`;

  logger.debug(`PUT ${url}`);
  const response = await apiClient.put<CalendarEvent>(url, data);

  return response.data;
};

export const deleteCalendarEvent = async ({ id }: { id: string }) => {
  const url = `/calendar/events/${id}`;

  logger.debug(`DELETE ${url}`);
  const response = await apiClient.delete<void>(url);

  return response.data;
};

export const createCalendarReminder = async ({
  propertyId,
  data,
}: {
  propertyId: string;
  data: CreateCalendarReminder;
}) => {
  const url = '/calendar/reminders';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<CalendarReminder>(url, { ...data, propertyId });

  return response.data;
};

export const updateCalendarReminder = async ({
  id,
  data,
}: {
  id: string;
  data: UpdateCalendarReminder;
}) => {
  const url = `/calendar/reminders/${id}`;

  logger.debug(`PUT ${url}`);
  const response = await apiClient.put<CalendarReminder>(url, data);

  return response.data;
};

export const deleteCalendarReminder = async ({ id }: { id: string }) => {
  const url = `/calendar/reminders/${id}`;

  logger.debug(`DELETE ${url}`);
  const response = await apiClient.delete<void>(url);

  return response.data;
};
